import React, { useState, useRef, useEffect } from "react";
import axios from "../../../../../axios/index";

// styles
import styles from "./AddToArchive.module.css";
import ModalStyles from "../../../DashboardReuseAbleComponents/Modal.module.css";
import Dstyles from "../../DashboardFileManagement.module.css";

// components
import Modal from "react-bootstrap/Modal";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import opacity from "react-element-popper/animations/opacity";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { ModalFooter } from "react-bootstrap";
import { addToArchiveValidate } from "./addToArchiveValidate";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IOSSwitch } from "./../../../DashboardArchivedFiles/ArchiveDetail/IOSSwitch";

const AddToArchiveRequestModal = props => {
  const id = props.id;
  const [btnLoader, setBtnLoader] = useState(false);
  const [errors, setErrors] = useState(false);
  const [reminderSendWay, setReminderSendWay] = useState([
    { id: 1, name: "پروفایل کاربری", status: false },
    { id: 2, name: "مرورگر شخصی", status: false },
    { id: 3, name: "پیامک", status: false },
    { id: 4, name: "همه موارد", status: true },
  ]);

  const [sendReminderWay, setSendReminderWay] = useState([
    { id: 1, name: "خودم", status: false },
    { id: 2, name: "مشاور", status: false },
    { id: 3, name: "مستاجر", status: false },
    { id: 4, name: "همه موارد", status: true },
  ]);

  // let options = { hour: 'numeric', minute: 'numeric' };
  // let today = new Date().toLocaleDateString('fa-IR', options).split(",")[1];

  const [archiveData, setArchiveData] = useState({
    reason: "",
    description: "",
    file: undefined,
    date: "",
    reminder: false,
    reminderTitle: "",
    reminderDescription: "",
    reminderDate: "",
    reminderTime: "",
  });
  const fileRef = useRef();

  useEffect(() => {
    const setValidate = async () => {
      await setErrors(addToArchiveValidate(archiveData));
    };
    setValidate();
  }, [archiveData]);

  return (
    <>
      <style type="text/css">
        {/* 420px */}
        {`
                .modal {
                    background: #3335 !important;
                }

                .modal-content {
                    width: 870px;
                    border-radius: 24px;
                    min-height: 769px;
                }

                .modal-header {
                    align-items: center !important;
                }

                .rmdp-container {
                    width: 370px;
                    height: 48px !important;
                    background: #F9F9F9;
                    border: 1px solid #E1E1E1;
                    border-radius: 24px;
                    display: flex !important;
                    align-items: center;
                    justify-content: start;
                    padding-right: 27px;
                    cursor: pointer;
                }
    
                .rmdp-wrapper {
                    width: 370px;
                    background: #FFFFFF !important;
                    border: 1px solid #E1E1E1 !important;
                    border-radius: 24px !important;
                    box-shadow: none !important;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .rmdp-input,
                .rmdp-input:focus {
                    width: 100%;
                    background: transparent;
                    border: none !important;
                    cursor: pointer !important;
                    box-shadow: none !important;
                }

                rmdp-top-class {
                    display: flex;
                    width: 100%;
                    align-items: center;
                    justify-content: center;
                }
                
                .rmdp-calendar {
                    width: 100%;
                }
                
                .rmdp-day-picker {
                    justify-content: center;
                }
                
                .rmdp-week, .rmdp-ym {
                    width: 370px;
                    padding: 0 27px;
                }

                @media only screen and (max-width: 765.98px) {
                    .rmdp-week, .rmdp-ym,.rmdp-container,
                    .rmdp-wrapper  {
                        width: 290px !important;
                    }


                    .modal-content {
                        width: 350px;
                    }
                  }
            `}
      </style>

      <ToastContainer
        position="top-right"
        autoClose={10000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered dir="rtl">
        <Modal.Header closeButton dir="rtl" style={{ border: "none" }}>
          <div className="w-100 d-flex align-items-start justify-content-between px-3">
            <div className={ModalStyles.title}>درخواست آرشیو فایل</div>
          </div>
        </Modal.Header>

        <Modal.Body style={{ transition: "all 0.15s ease-out", border: "none" }}>
          <div className="w-100 d-flex align-items-start justify-content-start flex-column">
            <div className="w-100 d-flex align-items-start justify-content-center flex-column mt-3">
              <div className={`mb-3 ${styles.input_header}`}>توضیحات</div>
              <textarea
                id="menuone"
                type="text"
                name="description"
                value={archiveData.description}
                className={`w-100 px-3 pt-3 ${styles.textarea}`}
                placeholder="توضیحات خود را وارد کنید"
                onChange={changeHandler}></textarea>
            </div>
          </div>
        </Modal.Body>
        <ModalFooter style={{ border: "none" }}>
          <div className="w-100 d-flex flex-column flex-wrap justify-content-center align-items-center mb-3">
            {btnLoader ? (
              <div className={Dstyles.btn_loader_container}>
                <div className={Dstyles.btn_spinner}></div>
              </div>
            ) : (
              <div className={`d-flex align-items-center justify-content-center ms-3 ${ModalStyles.filled_btn}`} onClick={submitHandler}>
                آرشیو
              </div>
            )}
            {/* {error && <span className='text-danger mt-4'>لطفا تمام فیلد هارا پرکنید</span>} */}
          </div>
        </ModalFooter>
      </Modal>
    </>
  );

  function changeHandler(e) {
    if (e.target.name === "file") {
      setArchiveData(prev => {
        return { ...prev, file: e.target.files[0] };
      });
    } else {
      setArchiveData(prev => {
        return { ...prev, [e.target.name]: e.target.value };
      });
    }
  }

  async function handleChange(value) {
    setArchiveData(prev => {
      return { ...prev, date: value };
    });
    // const userDate = `${value.year}-${value.month.number}-${value.day}`
    // const userDate = await `${value.year}-${value.month.number}-${value.day} ${value.hour}:${value.minute}:${value.second}`
  }

  async function reminderDateHandler(value) {
    setArchiveData(prev => {
      return { ...prev, reminderDate: value };
    });
  }

  async function timeHandler(value) {
    setArchiveData(prev => {
      return { ...prev, reminderTime: value };
    });
  }

  function switchHandler(event) {
    if (event.target.checked === true) {
      setArchiveData(prev => {
        return { ...prev, reminder: true };
      });
    } else {
      setArchiveData(prev => {
        return { ...prev, reminder: false };
      });
    }
  }

  function checkBoxHandler(checkBoxData, text) {
    if (text === "sendWay") {
      const updatedList = reminderSendWay.map(item => {
        if (item.id === checkBoxData.id) {
          if (checkBoxData.status) {
            // setReminderSendWay({ id: checkBoxData.id, name: checkBoxData.name, status: false });
            return { id: checkBoxData.id, name: checkBoxData.name, status: !item.status };
          } else {
            // setReminderSendWay({ ...item, status: true });
            return { id: checkBoxData.id, name: checkBoxData.name, status: !item.status };
          }
        } else if (checkBoxData.id === 4 && !checkBoxData.status === true) {
          return { ...item, status: true };
        } else if (checkBoxData.id === 4 && checkBoxData.status === true) {
          return { ...item, status: false };
        } else {
          return { ...item };
        }
      });
      setReminderSendWay(updatedList);
      // to know wich one of items is selected 👇👇
      // const test = updatedList.filter((item) => item.status === true)
    } else {
      const updatedList = sendReminderWay.map(item => {
        if (item.id === checkBoxData.id) {
          if (checkBoxData.status) {
            return { id: checkBoxData.id, name: checkBoxData.name, status: !item.status };
          } else {
            return { id: checkBoxData.id, name: checkBoxData.name, status: !item.status };
          }
        } else if (checkBoxData.id === 4 && !checkBoxData.status === true) {
          return { ...item, status: true };
        } else if (checkBoxData.id === 4 && checkBoxData.status === true) {
          return { ...item, status: false };
        } else {
          return { ...item };
        }
      });
      setSendReminderWay(updatedList);
    }
  }

  function submitHandler() {
    if (archiveData.description == "") {
      notify("لطفا تمام فیلد ها را پر کنید", "error");
      return;
    }
    notify("درحال آرشیو فایل", "success");
  }

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      postHandler();
    } else if (type === "successed") {
      toast.success(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    }
  }

  async function postHandler() {
    try {
      const emptyFile = new Blob([new ArrayBuffer(0)], { type: "application/pdf" });

      setBtnLoader(true);
      var data = new FormData();
      data.append("EstateId", id);
      data.append("ArchiveReason", "");
      data.append("Description", archiveData.description);

      const apiData = await axios.post(
        "Archive/Request",
        {
          EstateId: id,
          ArchiveReason: archiveData.reason,
          Description: archiveData.description,
        },
        {
          headers: { authorization: "Bearer " + props.userToken },
        }
      );
      setBtnLoader(false);
      notify("فایل با موفقیت آرشیو شد", "successed");
      props.onHide();
      window.location.reload();
    } catch (error) {
      notify("خطای سرور", "error");
    }
  }
};

export default AddToArchiveRequestModal;
